import { Link, useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import React, { useState, useEffect } from "react";
import "../../css/program/ManageProgram.css";
import "../../css/Manage.css";
import ProgramApi from "../../api/programApi";
import moment from "moment";
import { toast } from "react-toastify";
import SpaceApi from "../../api/spaceApi";
import { nullCheck } from "../../utils/check";

const ManageProgram = () => {
  let navigate = useNavigate();
  const { page } = useParams();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();

  const [currentFilter, setCurrentFilter] = useState(0);
  const [programActive, setProgramActive] = useState(null);
  const [programData, setProgramData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [startIndex, setStartIndex] = useState(0);
  const [pageIndex, setPageIndex] = useState([]);
  const [postsPerPage, setPostsPerPage] = useState(null);

  useEffect(() => {
    setSearchKeyword(searchParams.get("keyword") ? searchParams.get("keyword") : "");
    setCurrentFilter(searchParams.get("current") ? searchParams.get("current") : "");
    setCurrentPage(Number(page));
    getProgramList();
  }, [currentPage, location]);

  const getProgramList = async () => {
    try {
      const list = (
        await ProgramApi.Get({
          page: currentPage,
          size: 10,
          keyword: searchParams.get("keyword"),
          activation: searchParams.get("current"),
          managerId: sessionStorage.getItem("managerAuthority") === "MANAGER" ? sessionStorage.getItem("id") : "",
        })
      ).data.data;
      setProgramData((programData) => list.content);
      setTotalCount(list.totalCount);
      setPostsPerPage(list.content.length);

      const count = Math.ceil(list.totalCount / list.content.length / 4);

      for (let i = 1; i <= count; i++) {
        if (currentPage / 4 <= i) {
          setStartIndex(4 * (i - 1));
          console.log();
          return;
        }
      }
    } catch (err) {
      toast("서버에 문제가있습니다. 잠시후 다시 시도해주세요.");
    }
  };

  useEffect(() => {
    let page = Math.ceil(totalCount / postsPerPage);
    let arr = [];
    for (var i = 1; i <= page; i++) {
      arr.push(i);
    }
    setPageIndex(arr);
  }, [totalCount]);

  const programHandler = async (id, index, state) => {
    let copyData = [...programData];
    copyData[index].activation = state;
    setProgramData(copyData);
    let activationState = {
      activation: state,
    };
    try {
      await ProgramApi.PostActivation(id, activationState);
    } catch (error) {
      toast("서버에 문제가있습니다. 잠시후 다시 시도해주세요.");
    }
  };

  // const programFilter = async (item) => {
  //   try {
  //     const filter = (await ProgramApi.Get({ activation: item })).data.data;
  //     setProgramData(filter.content);
  //     setTotalCount(filter.totalCount);
  //     getProgramList();
  //   } catch (error) {
  //     toast("서버에 문제가있습니다. 잠시후 다시 시도해주세요.");
  //   }
  // };

  const [subMenuActive, setSubMenuActive] = useState(null);

  return (
    <div className="Manage-container">
      <section className="Manage-contents Manage-contents-table Manage-contents-table-program">
        <span>프로그램 관리</span>
        <div className="manage-table-container">
          <div className="Manage-program-filter">
            <a
              className={currentFilter === "" ? "filter-btn-active" : ""}
              onClick={() => {
                // setCurrentFilter(0);
                // programFilter("");
                navigate(`/admin/program/1?keyword=${searchKeyword}&current=`);
              }}
            >
              전체
            </a>
            <a
              className={currentFilter === "true" ? "filter-btn-active" : ""}
              onClick={() => {
                // setCurrentFilter(1);
                // programFilter(true);
                navigate(`/admin/program/1?keyword=${searchKeyword}&current=true`);
              }}
            >
              일반
            </a>
            <a
              className={currentFilter === "false" ? "filter-btn-active" : ""}
              onClick={() => {
                // setCurrentFilter(2);
                // programFilter(false);
                navigate(`/admin/program/1?keyword=${searchKeyword}&current=false`);
              }}
            >
              종료
            </a>
          </div>
          <div className="Manage-program-search-container">
            <div className="Manage-program-search-number">
              <span>전체 갯수</span>
              <span>{totalCount}</span>
            </div>
            <div className="Manage-program-search">
              <div style={{ position: "relative" }}>
                <input
                  className="table-search-input"
                  type="text"
                  placeholder="검색어를 입력하세요"
                  onChange={(e) => {
                    setSearchKeyword(e.target.value);
                  }}
                  value={searchKeyword}
                />
                <img
                  src="/img/search.svg"
                  alt=""
                  style={{
                    position: "absolute",
                    right: "10px",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    navigate(`/admin/program/1?keyword=${searchKeyword}&current=${currentFilter}`);
                  }}
                />
              </div>
              <div
                onClick={async () => {
                  const managerAuthority = sessionStorage.getItem("managerAuthority");

                  if (managerAuthority === "MANAGER") {
                    const response = await SpaceApi.Get({
                      size: 1,
                      managerId: sessionStorage.getItem("id"),
                    });
                    if (nullCheck(response.data.data.content)) {
                      toast("공간을 먼저 등록해주세요.");
                      return;
                    }
                  }
                  navigate("/admin/program/add/root");
                }}
              >
                <img src="\img\sidebar-plus-icon.svg" />
                <span>프로그램 추가</span>
              </div>
            </div>
          </div>
          <div className="Manage-table manage-table-program">
            <table>
              <thead>
                <tr>
                  <th>상태</th>
                  <th>프로그램명</th>
                  <th>소요시간</th>
                  <th>등록 관리자</th>
                  <th>상세보기</th>
                </tr>
              </thead>
              <tbody>
                {programData.map((item, index) => {
                  let requiredTime = moment(item.requiredTime, "HH:mm").format("H시간");
                  return (
                    <tr key={index}>
                      <td className="table-sub-catagory-container">
                        <a
                          onClick={() => {
                            if (subMenuActive === index) setSubMenuActive(null);
                            else setSubMenuActive(index);
                          }}
                        >
                          <span>{item.activation ? "일반" : "종료"}</span>
                          <img src="/img/table-togle.svg" />
                        </a>
                        {subMenuActive === index ? (
                          <ul className="table-sub-menu table-sub-menu-program">
                            <li
                              onClick={() => {
                                programHandler(item.id, index, true);
                                setSubMenuActive(null);
                              }}
                            >
                              일반
                            </li>
                            <li
                              onClick={() => {
                                programHandler(item.id, index, false);
                                setSubMenuActive(null);
                              }}
                            >
                              종료
                            </li>
                          </ul>
                        ) : null}
                      </td>
                      <td>
                        <span>{item.title}</span>
                      </td>
                      <td>{requiredTime}</td>
                      <td>{item.manager.email}</td>
                      <td>
                        <Link to={`/admin/program/detail/${item.id}`} state={{ id: item.id }}>
                          <img src="\img\see-more-btn-plus.svg" />
                          <span>보기</span>
                        </Link>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <div className="manage-table-pagenation-container">
              <div className="manage-table-pagenation">
                <a
                  onClick={() => {
                    if (currentPage <= 1) {
                      return;
                    } else {
                      navigate(`/admin/program/${currentPage - 1}?keyword=${searchKeyword}&current=${currentFilter}`);
                    }
                  }}
                >
                  <img src="\img\chevron-left.svg" />
                </a>
                {pageIndex.slice(startIndex, startIndex + 4).map((item, index) => {
                  return (
                    <a
                      key={index}
                      className={currentPage === item ? "pagenation-focus" : null}
                      onClick={() => {
                        navigate(`/admin/program/${item}?keyword=${searchKeyword}&current=${currentFilter}`);
                      }}
                    >
                      {item}
                    </a>
                  );
                })}
                <a
                  onClick={() => {
                    if (currentPage >= pageIndex.length) {
                      return;
                    } else {
                      navigate(`/admin/program/${currentPage + 1}?keyword=${searchKeyword}&current=${currentFilter}`);
                    }
                  }}
                >
                  <img src="\img\chevron-right.svg" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ManageProgram;
